/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import { trackEvent } from '../../../utils/analytics';
import EventNames from '../../../utils/event-name-constants';
import GET_JSON_VARIABLE from '../../../gql/queries/get-json-variable.gql';

// eslint-disable-next-line react/prop-types
function QuickLinkCard({ item, compact = false }) {
  const {
    url, title, icon_url: iconUrl, type,
  } = item;
  const { QUICK_LINK_CLICKED } = EventNames;
  const router = useRouter();
  const iconSize = compact ? 48 : 72;
  const titleClasses = compact
    ? 'text-xs mt-2 font-normal text-black w-[72px] leading-tight'
    : 'text-base mt-2 font-normal text-black w-[120px] leading-tight';
  const handleClick = () => {
    trackEvent(QUICK_LINK_CLICKED, {
      link: type === 'web' ? url : `/feature/${type}`,
      quickLinkTitle: title,
    });
    if (type === 'web') {
      router.push(url);
    } else router.push(`/feature/${type}`);
  };
  return (
    <div className="flex flex-col items-center text-center" target="__blank" onClick={handleClick}>
      <Image
        width={iconSize}
        height={iconSize}
        src={iconUrl}
        alt="quick-banner"
      />
      <h3 className={titleClasses}>
        {title}
      </h3>
    </div>
  );
}

QuickLinkCard.propTypes = {
  item: PropTypes.object.isRequired,
};

function QuickLinksList({ remoteConfigData }) {
  const { data } = useQuery(GET_JSON_VARIABLE, {
    variables: {
      name: 'quick-links',
      language: 'en',
    },
  });

  const [showAllMobileLinks, setShowAllMobileLinks] = useState(false);

  const quickLinks = data?.getJsonVariable?.value?.quick_links || [];
  const visibleMobileLinks = showAllMobileLinks
    ? quickLinks
    : quickLinks.slice(0, 4);

  return (
    <section className="pt-[34px] lg:pt-[52px]">
      <div className="flex justify-between mb-[18px] lg:mb-[34px] items-center pr-5 lg:pr-0">
        <h2 className="xl:text-2xl text-lg font-semibold">{remoteConfigData?.heading}</h2>
      </div>

      <div className="flex flex-wrap gap-y-4 md:hidden">
        {visibleMobileLinks.map((item) => (
          <div key={item?.title} className="w-1/5 flex justify-center">
            <QuickLinkCard item={item} compact />
          </div>
        ))}

        {quickLinks.length > 4 && (
          <div className="w-1/5 flex justify-center">
            <button
              type="button"
              onClick={() => setShowAllMobileLinks((prev) => !prev)}
              className="flex flex-col items-center text-center focus:outline-none gap-2"
            >
              <div className="w-8 h-8 mt-2 rounded-full border border-gray-300 flex items-center justify-center">
                <span className="leading-none text-lg mb-2">…</span>
              </div>
              <h3 className="text-xs mt-2 font-normal text-black leading-tight">
                {showAllMobileLinks ? 'View Less' : 'View More'}
              </h3>
            </button>
          </div>
        )}
      </div>

      <div className="hidden md:flex flex-wrap gap-8">
        {quickLinks.map((item) => (
          <QuickLinkCard item={item} key={item?.title} />
        ))}
      </div>
    </section>
  );
}
QuickLinksList.propTypes = {
  remoteConfigData: PropTypes.any,
};
export default QuickLinksList;
